export default __webpack_public_path__ + "static/media/img1.a0707432.svg";